import { MuiFileInput, MuiFileInputProps } from 'mui-file-input'

export const FileUploader = (props: MuiFileInputProps<false>) => {
    return <MuiFileInput {...props} fullWidth />
}